export enum CompanyConfirmationViewState {
  Main = 'main',
  Email = 'email',
  SuccessChange = 'success-change',
  SuccessConfirmation = 'success-confirmation',
  Failure = 'failure',
}
